export default {
    ADS_TYPE: [
        {id: 1, value: 'Adsense', key: 'googleAds'},
        {id: 2, value: 'Orqidea', key: 'orquideaAds'}
    ],
    ARTICLE_STATUS: [
        {id: 1, value: 'Activo', key: 'active', color: 'cVerde', actionName: 'activar'},
        {id: 2, value: 'Suspendido', key: 'suspended', color: 'cGris', actionName: 'suspender'}
    ],
    ARTICLE_STATUS_TYPE: {
        ACTIVE: 1,
        SUSPENDED: 1
    },
    ARTICLE_TYPE: [
        {id: 1, value: 'Historia', key: 'history', useId: true},
        {id: 2, value: 'Noticia', key: 'news', useId: true},
        {id: 3, value: 'Media', key: 'entry', useId: true}
    ],
}



// WEBPACK FOOTER //
// ./src/constants/admin.js